<template>
  <div class="msg-gray">
    <gray-card
      v-if="hasExtuinInfo"
      :processedText="processedText"
      :text="text"
      :uin-info="uinInfo"
    ></gray-card>
    <span
      v-html="processedText"
      :class="device"
      v-else
    ></span>
  </div>
</template>

<script>
import Utils from '@/utils/string';
import GrayCard from './gray-card.vue';

export default {
  components: {
    GrayCard,
  },
  props: {
    device: {
      type: String,
      default: 'pc',
    },
    data: Object,
  },
  computed: {
    text() {
      return this.data?.content?.gray;
    },
    uinInfo() {
      return this.data?.crm?.msg_webim_extra_data;
    },
    hasExtuinInfo() {
      /* eslint-disable max-len */
      return this.uinInfo?.str_avatar && this.uinInfo?.str_external_name;
    },
    processedText() {
      let text = this.data?.content?.gray || '';
      // 过滤html，保留a标签
      text = Utils.filterHTML(text);
      text = text.replace('\r\n', '<br>');
      return text;
    },
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.msg-gray {
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  span {
    border-radius: 12px;
    padding: 2px 12px;
    display: inline-block;
    color: #B4B8C4;
    &.pc {
      background: #eceef1;
    }
    &.h5 {
      border-radius: 6px;
      background: #fff;
    }
  }
}
</style>
